var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { createRing3DGeometry } from "../../geoms/createRing3DGeometry";
import { Meshes } from "./Meshes";
var Rings = /** @class */ (function (_super) {
    __extends(Rings, _super);
    function Rings(params, $paramObjArray) {
        var _this = _super.call(this, params) || this;
        _this.innerRadius = 110 * 0.5;
        _this.outerRadius = 172 * 0.5;
        // ------------------------------ Geometry
        _this.geometry = createRing3DGeometry(_this.innerRadius, _this.outerRadius, 32, 8);
        // ------------------------------ Meshes
        _this._createMeshes($paramObjArray);
        _this.scale.set(1, 1, 1);
        _this._onChangeScale();
        return _this;
    }
    Rings.prototype.atChangeGeometry = function () {
        this.geometry = createRing3DGeometry(this.innerRadius, this.outerRadius, 32, 8);
    };
    return Rings;
}(Meshes));
export { Rings };
